export default __webpack_public_path__ + "faf921d8bf89da64342f45e8a3828e8d.png";